<template>
  <filter-parent
    :title="texts.languages"
    :start-open="true"
    :icon="'globe-languages'"
  >
    <multiselect
      v-model="languages"
      :options="languageOptions"
      :placeholder="texts.startTyping"
    />
  </filter-parent>
</template>

<script>
import FilterParent from '../common/FilterParent.vue';
import Multiselect from 'Components/MultiSelect.vue';
import { useLanguageOptions } from 'Composables/useLanguageOptions';

export default {
  name: 'LanguageFilter',

  components: {
    FilterParent,
    Multiselect,
  },

  setup() {
    const { getLanguageOptions } = useLanguageOptions();
    return { getLanguageOptions };
  },

  props: {
    users: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      texts: window.theme_vars.counselorGridTexts,
    };
  },

  computed: {
    languageOptions() {
      return this.getLanguageOptions(this.users);
    },

    languages: {
      get() {
        return this.$store.state.counselorGrid.filteredLanguages;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredLanguages', value);
      },
    },
  },
};
</script>
